module.exports = __webpack_public_path__ + "b7c31dfb7662cc9bbaf45b6a3f06fc00.pdf";